
import { Component, Prop, Vue } from "nuxt-property-decorator";
import PageJumpNavigation from "~/components/molecules/nav/PageJumpNavigation.vue";
import type { JumpNavItem } from "~/types/ContentPage";

@Component({
  components: {
    PageJumpNavigation,
  },
})
export default class ContentPageLayout extends Vue {
  @Prop({ required: true }) jumpNavItems!: JumpNavItem[];
  @Prop({ default: false }) compact!: boolean;
}
